import { useSelector } from "react-redux";

import { VISIT_HISTORY } from "../../../api/allApi_List";
import VisitsList from "../components/visitList/VisitsList";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";

const formatDate = (date) => date.toISOString().split("T")[0];
const today = formatDate(new Date());
const fromDate = formatDate(
  new Date(new Date().setMonth(new Date().getMonth() - 1))
);

const VisitsPage = () => {
  const { isLoaded } = useFetchData(`${VISIT_HISTORY}${fromDate}/${today}`);
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;

  return (
    <MainPageLayout
      headerConfig={{ title: "Visits" }}
      numberOfData={dataLength}
    >
      {isLoaded && !error ? (
        <VisitsList visitsData={data} />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default VisitsPage;
